import React, { Fragment } from 'react';
import "./home_page_mobile.scss";
import TemplatePageFooter from "../../template_page/template_page_footer/template_page_footer";
import { delay } from "../../../utils/utils";
import { Translation } from "react-i18next";
import { HOME_PAGE_FOOTER_LINKS } from "../../../config/footer_contents";
import TemplateComponent from "../../template_page/template_component/template_component";
import HomePageMobileCard1 from "../home_page_mobile_card/home_page_mobile_card1/home_page_mobile_card";
import HomePageMobileCard2 from "../home_page_mobile_card/home_page_mobile_card2/home_page_mobile_card2";
import HomePageMobileCard3 from "../home_page_mobile_card/home_page_mobile_card3/home_page_mobile_card3";
import HomePageMobileCard4 from "../home_page_mobile_card/home_page_mobile_card4/home_page_mobile_card4";
import HomePageMobileCard5 from "../home_page_mobile_card/home_page_mobile_card5/home_page_mobile_card5";
import HomePageMobileCard6 from "../home_page_mobile_card/home_page_mobile_card6/home_page_mobile_card6";
import HomePageMobileCard7 from "../home_page_mobile_card/home_page_mobile_card7/home_page_mobile_card7";
import HomePageDesktopMessage from "../home_page_desktop_message/home_page_desktop_message";
import { insertHtml } from "../../../utils/dom";

const CARDS_LOADING_STEP_MILLISECONDS = 800;

class HomePageMobile extends TemplateComponent {

    constructor(props) {
        super(props);
        this.state = {
            cards: []
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if this is the first time we have got the cards to be shown
        if ((!prevProps.cards || prevProps.cards.length === 0) && this.props.cards && this.props.cards.length > 0) {
            let cards = this.props.cards.slice();
            this.addCardsProgressively(cards);
        }
    }

    addCardsProgressively = (cards) => {
        let firstCards = cards.splice(0, 2);
        this.setState({
            cards: [...this.props.cards, ...firstCards]
        });
        if (cards.length > 0) {
            delay(CARDS_LOADING_STEP_MILLISECONDS).then(() => this.addCardsProgressively(cards));
        }
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (this.state.cards !== nextState.cards)
            || (this.props.cards !== nextProps.cards && nextProps.cards && !!nextProps.cards.length && nextProps.cards.length > 0);
    }

    render() {
        return (
            <div id="home-page" className="mobile">
                <Translation>
                    {(t) => (
                        <Fragment>
                            {this.props.banners && this.props.banners.length && <HomePageDesktopMessage {...this.props} />}
                            <div className="home-slides-container">
                                <div className="apply-button socialtv">
                                    <a href={'https://socialtv.luiss.it'}>Luiss Social TV</a>
                                    {/*<a href={'https://youtube.com/live/fzTgR0FZ7cY'}>Luiss Social TV</a> */}
                                </div>
                                {/* <div className="apply-button">
                                    <a href={t('HOME PAGE apply button url')}>{t('HOME PAGE apply button label')}</a>
                                </div> */}
                                {this.props.cards && this.props.cards.map((content, index) => {
                                    switch (content.type) {
                                        case '':
                                            return <HomePageMobileCard1 key={"home-card-" + index} {...content} />;
                                        case 'type1':
                                            return <HomePageMobileCard3 key={"home-card-" + index} {...content} />;
                                        case 'type2':
                                            return <HomePageMobileCard2 key={"home-card-" + index} {...content} />;
                                        case 'type3':
                                            return <HomePageMobileCard4 key={"home-card-" + index} {...content} />;
                                        case 'type4':
                                            return <HomePageMobileCard5 key={"home-card-" + index} {...content} />;
                                        case 'type5':
                                            return <HomePageMobileCard6 key={"home-card-" + index} {...content} />;
                                        case 'type6':
                                            return <HomePageMobileCard7 key={"home-card-" + index} {...content} />;
                                        default:
                                            return null;
                                    }
                                }
                                )}
                            </div>
                            <TemplatePageFooter linksKeys={HOME_PAGE_FOOTER_LINKS} />
                        </Fragment>
                    )}
                </Translation>
            </div>
        );
    }
}
export default HomePageMobile;
